import React, { ComponentProps, createElement } from "react";

import { CollectionCard } from "@hl/shared-features/lib/features/builder/collection-card/CollectionCard";
import { Box } from "@mantine/core";
import { Parser, ProcessNodeDefinitions } from "html-to-react";

import { HLCollectionCardPlugin } from "./plugins/HLCollectionCardPlugin";

type CurationViewerProps = {
  html: string;
};

const HLComponentsMap = {
  [HLCollectionCardPlugin.type]: CollectionCard,
} as const;

export const CurationViewer = (props: CurationViewerProps) => {
  const { html } = props;

  const htmlInput = html;
  // @ts-ignore
  const htmlToReactParser = new Parser();
  // @ts-ignore
  const processNodeDefinitions = new ProcessNodeDefinitions();
  const isValidNode = function () {
    return true;
  };

  // Order matters. Instructions are processed in
  // the order they're defined
  type ProcessNode = {
    name: string;
    attribs: Record<string, string>;
  };
  const processingInstructions = [
    {
      // This is REQUIRED, it tells the parser
      // if we want to insert our React
      // component as a child or replace it
      replaceChildren: false,
      shouldProcessNode: function (node: ProcessNode) {
        if (node.name !== "div") return false;

        const type = node.attribs["data-gjs-type"];
        const hlComponent = HLComponentsMap[type];

        if (hlComponent == null) return false;

        console.log("Processing none", { type, hlComponent, node });

        return true;
      },
      processNode: function (node: ProcessNode, children: string[]) {
        const type = node.attribs["data-gjs-type"];

        /* eslint-disable @typescript-eslint/no-explicit-any */
        const hlComponent = HLComponentsMap[type];
        /* eslint-disable @typescript-eslint/no-explicit-any */
        const props = JSON.parse(children[0] ?? "{}") as ComponentProps<any>;
        return createElement(hlComponent, props);
      },
    },
    {
      // Anything else
      shouldProcessNode: function () {
        return true;
      },
      processNode: processNodeDefinitions.processDefaultNode,
    },
  ];

  const reactComponent = htmlToReactParser.parseWithInstructions(
    htmlInput,
    isValidNode,
    processingInstructions
  );

  // const reactHtml = ReactDOMServer.renderToStaticMarkup(reactComponent);

  return <Box id="curation-viewer">{reactComponent}</Box>;
};
